import { emailAddresses } from './constants';

export const getEmailProvider = (email: string) => {
  const [provider] =
    Object.entries(emailAddresses).find(([provider, values]) =>
      values.find((value) => email?.includes(value))
    ) || [''];

  return provider;
};
